import store from '@/store/store';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

class AlteSalarioController {

  public static async getAltesalario(
    nrVinculo: number,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getAltesalario';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const alteSalario: any[] = response.data.dataset.data;
  
      return alteSalario;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar as alterações salariais';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }

    return [];
  }
}

export default AlteSalarioController;
